import React, { useState } from 'react'

export default function Portfolio() {
  const [tab, setTab] = useState("all");
  return (
    <div>

    
    <div  className="firstportfolio" >
      <div className="image-container">
        <img  className="portfolioimage" src="/images/Port-folio.png" alt="full width" ></img>
      </div>
     
          <div className="imagecontainer">
      {/* Dropdown */}
      <h1 className='allcategory'>ALL CATEGORY</h1>
        <div className="dropdown"></div>
      <select className='allwebgraphics'
        value={tab}
        onChange={(e) => setTab(e.target.value)}
        
      >
        <option value="all">All</option>
        <option value="website">Website</option>
        <option value="graphics">Graphics</option>
      </select>

      {/* Content area */}
      <div className="alltab" >
        {tab === "all" && (
          <div>
    
        <a href="https://corpfacilitators.com/"target="_blank"rel="noopener noreferrer">
        <img  className="corpweb"src="/images/Corp-web.png"alt="corpweb"></img>
        </a>
         <img className="corpweb-second" src="/images/grapost.png" alt="corpweb"></img>
          </div>
        )}

        {tab === "website" && (
          <div>
             <a href="https://thefashionfinds.in/" target="_blank" rel="noopener noreferrer">
        <img  className ="corpweb" src="/images/Fashion-find.png"  alt='Fashion-find'></img>
        </a>
        <a href="https://corpfacilitators.com/"target="_blank"rel="noopener noreferrer">
        <img className="corpweb-second" src="/images/Corp-web.png" alt="corpweb"></img>
        </a>
          </div>
        )}
        {tab === "graphics" && (
         
        <img className="corpweb-second" src="/images/grapost.png" alt="corpweb"></img>
   
        )}
      </div>
    </div>

    </div>
    
    </div>
  )
}






  
    
